
import { Component, Mixins } from "vue-property-decorator";
import { TurnedTextFormatKinds, TurnedTextStyle } from "../../../../../../documaker/domain/format/objects";
import { ITurnedTextStylePropertyEditable, instanceOfITurnedTextStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TurnedTextStylePropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITurnedTextStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITurnedTextStylePropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTurnedTextStyleEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITurnedTextStylePropertyEditable(s) && s.turnedTextStyle().isEditable(), false);
  }

  get turnedTextStyle(): TurnedTextStyle {
    return this.readPropertyOrDefault(s => TurnedTextStyle.from(s.turnedTextStyle().getValue()), new TurnedTextStyle(TurnedTextFormatKinds.None));
  }

  set turnedTextStyle(value: TurnedTextStyle) {
    this.writePropertyWhenValid(s => s.turnedTextStyle().setValue(TurnedTextStyle.to(value)));
  }
}
